// extracted by mini-css-extract-plugin
module.exports = {"preloader":"Loader_preloader__3SJvB"};